import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=54c4c3b5&scoped=true"
import script from "./nav-bar.vue?vue&type=script&lang=js"
export * from "./nav-bar.vue?vue&type=script&lang=js"
import style0 from "./nav-bar.vue?vue&type=style&index=0&id=54c4c3b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4c3b5",
  null
  
)

export default component.exports